import { useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setDestination } from "../../modules/reducers/destination/destination";

const useControlQuickMenu = ({ needSelectBranch, openModal }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const swiperRef = useRef(null);

  const { pathname } = useLocation();

  const handleItemClick = (item) => {
    const { value, requiresStore, label } = item;
    if (needSelectBranch && requiresStore) {
      openModal();
      dispatch(setDestination({ from: pathname, to: value, label }));
    } else if (/^https?:\/\//.test(value)) {
      window.location.href = value;
      dispatch(setDestination({ from: pathname, to: value, label }));
    } else {
      navigate(value);
    }
  };

  return { handleItemClick, swiperRef };
};

export default useControlQuickMenu;
